import teaserWrapper from './components/teaser-box/wrapper';

/**
 * @param {Object} teaserObj - product
 * @returns {string} product tile HTML
 */
export default teaserObj => {
    return `
        <div class="content-asset-slot-container teaser promo-tile-teaser teaser-magazine-full-bg-style bottom-content">
            <div class="teaser-inner">
                <div class="teaser-wrapper">
                    ${teaserWrapper(teaserObj)}
                </div>
            </div>
        </div>`;
};
